export default {"src":"/_next/static/media/gto.f10c9a3c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};